import { Async, toAsyncFetched } from '@client/new/helpers/types';
import {
  SubscriptionBundlesVM,
  useSubscriptionBundlesVM,
} from '../subscription/viewModel/subscriptionBundles.viewModel';
import {
  OtpBundlesVMData,
  useOtpBundlesVM,
} from '../otp/viewModel/otpBundles.viewModel';

type BundlesVMData = {
  otpBundles: OtpBundlesVMData;
  subscriptionBundles: SubscriptionBundlesVM;
};

type BundlesVM = BundlesVMData;

export const useBundlesVM = ({
  creatorId,
}: {
  creatorId: number;
}): Async<BundlesVM> => {
  const subscriptionVM = useSubscriptionBundlesVM({
    creatorId,
  });

  const otpVM = useOtpBundlesVM({
    creatorId,
  });
  if (subscriptionVM.type !== 'fetched') return subscriptionVM;
  if (otpVM.type !== 'fetched') return otpVM;

  return toAsyncFetched<BundlesVM>({
    otpBundles: otpVM.value,
    subscriptionBundles: subscriptionVM.value,
  });
};
